/**
 * 放置全局一些通用配置
 */
export const DEFAULT_DATA = "--";

// 如果此处修改了，请同步修改src\assets\style\theme.less中的@ant-prefix
export const ANT_PREFIX = "khAnt";

// hotfix-28822: 工作台存在业务规则告警记录卡片(需要隐藏)，与原型图不符
// 定义需要隐藏的菜单Code列表
export const HIDDEN_MENU_CODES = ["rule-engine/Alarm/Log"];

// 定义树节点接口
interface TreeNode {
  code: string;
  children?: TreeNode[];
  [key: string]: any; // 允许其他任意属性
}

// 定义过滤函数类型
type TreeFilterFunction = (
  treeData: TreeNode | TreeNode[],
  hiddenCodes?: string[]
) => TreeNode[] | TreeNode | null;

/**
 * 过滤树节点，移除需隐藏的节点及其子节点
 * @param treeData - 树结构数据（支持数组或单个节点对象）
 * @param hiddenCodes - 需要隐藏的节点code数组
 * @returns 过滤后的树结构（可能为空数组/null/过滤后的节点）
 */
export const filterHiddenMenuCodes: TreeFilterFunction = (
  treeData,
  hiddenCodes = HIDDEN_MENU_CODES
) => {
  // 创建Set提高查找效率
  const hiddenSet = new Set(hiddenCodes);

  // 内部递归过滤函数
  const filterNode = (node: TreeNode): TreeNode | null => {
    // 1. 如果当前节点需要隐藏，直接返回null（整个子树移除）
    if (hiddenSet.has(node.code)) {
      return null;
    }

    // 2. 深度优先处理子节点（如果有）
    const filteredChildren: TreeNode[] = [];
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        const filteredChild = filterNode(child);
        if (filteredChild) {
          filteredChildren.push(filteredChild);
        }
      }
    }

    // 3. 返回节点副本（避免修改原数据）并更新子节点
    return {
      ...node,
      children: filteredChildren.length > 0 ? filteredChildren : undefined,
    };
  };

  // 处理数组形式的树结构（多根节点）
  if (Array.isArray(treeData)) {
    return treeData
      .map((node) => filterNode(node))
      .filter(Boolean) as TreeNode[];
  }
  // 处理对象形式的单根节点
  else if (treeData && typeof treeData === "object") {
    return filterNode(treeData as TreeNode);
  }

  // 空数据直接返回
  return treeData;
};
